// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3liP4","alert":"SettungsInbox_alert__QA_WH"};